<template>
  <div v-if="bankDetails" class="bank-details-info" :class="themeClass">
    <div class="row g-2 align-items-center">
      <!-- Columna 1: Razón Social / RIF -->
      <div class="col-6 col-md-4 text-center text-md-start">
        <div class="mb-1">
          <span class="card-label-mini">Razón Social / RIF</span>
          <div class="fw-bold mt-1 info-text">{{ bankDetails.dni || '-' }}</div>
        </div>
      </div>
      
      <!-- Columna 2: Banco -->
      <div class="col-6 col-md-4 text-center text-md-start">
        <div class="mb-1">
          <span class="card-label-mini">Banco</span>
          <div class="fw-bold mt-1 fs-6-compact bank-name-text">{{ bankDetails.name_bank || '-' }}</div>
        </div>
      </div>
      
      <!-- Columna 3: Datos de pago (Teléfono o Cuenta) -->
      <div class="col-12 col-md-4 text-center text-md-start mt-2 mt-md-0">
        <div>
          <div v-if="paymentMethod === 'pago_movil'">
            <span class="card-label-mini">Teléfono</span>
            <div class="fw-bold mt-1 account-number-dark d-inline-block">{{ bankDetails.phone || '-' }}</div>
          </div>
          <div v-else>
            <span class="card-label-mini">Número de Cuenta</span>
            <div class="fw-bold mt-1 account-number-dark d-inline-block">{{ bankDetails.account || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  bankDetails: {
    type: Object,
    default: null
  },
  paymentMethod: {
    type: String,
    default: 'pago_movil'
  },
  theme: {
    type: String,
    default: 'dark',
    validator: (value) => ['dark', 'light'].includes(value)
  }
});

const themeClass = computed(() => `theme-${props.theme}`);
</script>

<style scoped>
.bank-details-info {
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 15px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}

.card-label-mini {
  font-size: 0.7rem;
  text-transform: uppercase;
  display: block;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.fs-6-compact {
  font-size: 0.9rem;
  line-height: 1.2;
}

.account-number-dark {
  font-family: monospace;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  padding: 5px 10px;
  border-radius: 6px;
}

/* Theme Dark (maroon background context) */
.theme-dark {
  background-color: rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.theme-dark .card-label-mini {
  color: rgba(255, 255, 255, 0.6);
}
.theme-dark .bank-name-text,
.theme-dark .info-text {
  color: #ffffff;
}
.theme-dark .account-number-dark {
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.25);
  border: 1px dashed rgba(255, 255, 255, 0.2);
}

/* Theme Light (sidebar/gray background context) */
.theme-light {
  background-color: rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.theme-light .card-label-mini {
  color: #556072;
}
.theme-light .bank-name-text,
.theme-light .info-text {
  color: #1a202c;
}
.theme-light .account-number-dark {
  color: #1a202c;
  background-color: rgba(255, 255, 255, 0.85);
  border: 1px dashed rgba(0, 0, 0, 0.18);
}
</style>
